module.exports = __webpack_public_path__ + "static/media/clover-station-pos-device-any-business-large.bb622dc1.jpg";